import React, { useContext, useState, useEffect, MouseEventHandler } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent, Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { DatCatSizeDataItem, upDatCatSizeDataItem, SiteEntry } from '../../services/interfaces';
import { saveDatCatSize, deleteDatCatSize, getDatCatSizeList } from '../../services/apiAdminService';
import { getStatusList, getSubStatusList } from '../../services/apiService';
import { process, State, DataResult } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { data } from 'react-router-dom';
import { ConfirmDialog } from '../ConfirmDialog';
import { SiteList, StatusList } from '../FormComponents';

interface PageState {
    skip: number;
    take: number;
}

//const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'category', dir: 'asc' }],
    filter: undefined,
    skip:0,
    take:20
};

interface editProps{
    size:DatCatSizeDataItem,
    title: string,
    onClose: () => void;
    action:string
}

export interface NewSize
{
    category:string
    columnWidth:number
    gutter:number
    depthConversion:number
    modYNB:string
    EPSPathNum:number
    tempChar:string
    tempInt:number
    siteCode:string        
}


const EditDialog=(props:editProps)=>{

    const [newSize, setNewSize]= useState<NewSize>(
        {
            category:"",
            columnWidth:0,
            gutter:0,
            depthConversion:0,
            modYNB:"",
            EPSPathNum:0,
            tempChar:"",
            tempInt:0,
            siteCode:"",
        }
    );
    const [dlgTitle, setDlgTitle]=useState<string>("");
    const [selectedSize,setSelectedSize]=useState([]);
    const [showDelConfirm, setShowDelConfirm]=useState(false);
    const [showDeleteButton, setShowDeleteButton]=useState(true);
    const [intAction,setIntAction]=useState("");
    const [siteValid, setSiteValid]=useState(false);
    const [pubValid, setPubValid]=useState({
        pubNum:false,
        pubName:false,
        pubSite:false
    });
    const setSiteCode=(e: SiteEntry[])=>{
        setNewSize({...newSize, siteCode: (e[0].code) || ''})        
    }

    const setCategory=(e: InputChangeEvent)=>{
        setNewSize({...newSize, category: (e.value)})
    }

    const setColWidth=(e: InputChangeEvent)=>{
        setNewSize({...newSize, columnWidth: Number(e.value)})
    }

    const setGutter=(e: InputChangeEvent)=>{
        setNewSize({...newSize, gutter: Number(e.value)})
    }

    const setDepthConv=(e: InputChangeEvent)=>{
        setNewSize({...newSize, depthConversion: Number(e.value)})
    }
    


    const validateSize= async()=>{
        var statusValid={
            site:false,
            category:false,
        }
        if (newSize.category!=""){
            statusValid.category=true;
        }
        if (newSize.siteCode!==""){
            statusValid.site=true;
            setSiteValid(true);            
        }
        return statusValid;
    }
    

    const viewDeleteButton=()=>{
        setShowDeleteButton(true);
    }

    const hideDeleteButton=()=>{
        setShowDeleteButton(false);
    }


    const viewDelConfirm=()=>{
        setShowDelConfirm(true);
    }

    const hideDelConfirm=()=>{
        setShowDelConfirm(false);
    }



    const deleteThisSize=()=>{
        if (props.action=="Edit"){
            const category = newSize.category;
            const site = newSize.siteCode;
            if (site!="" && category!=""){
               deleteDatCatSize(category,site);
            }
        }        
        hideDelConfirm();
        props.onClose();
    }



    const saveThisSize= async ()=>{

        var oCategory;
        var oModYNB;
        var ositeCode;
        console.log(newSize);
        validateSize().then((sizeValid)=>{
             if (sizeValid.category===true && sizeValid.site===true){
                 if (intAction==="Edit"){
                    //edit existing pub
                    oCategory=props.size.category;
                    oModYNB=props.size.modYNB;
                    ositeCode=props.size.siteCode;
                 }else{
                     //create new pub
                    oCategory="";
                    oModYNB="";
                    ositeCode="";
                 }
                 var formData:upDatCatSizeDataItem = {
                    oCategory: oCategory,
                    oModYNB:oModYNB,
                    ositeCode:ositeCode,
                    siteCode: newSize.siteCode,
                    category: newSize.category,
                    columnWidth: newSize.columnWidth,
                    gutter: newSize.gutter,
                    depthConversion: newSize.depthConversion,
                    modYNB:newSize.modYNB,
                    EPSPathNum:newSize.EPSPathNum,
                    tempChar:newSize.tempChar,
                    tempInt: newSize.tempInt
                  };
                 console.log(formData);
                 saveDatCatSize(formData).then((data)=>{
                     console.log(data);
                     props.onClose();
                 });    
             }else{
                 console.log("Missing fields");
             }    
        });
        
    }

    useEffect(()=>{
        console.log(newSize);
    },[newSize])

    useEffect(() => {  
        setDlgTitle(props.title);
        console.log(props.size); 
        if (props.size){
            setNewSize({
                category:props.size.category,
                columnWidth:props.size.columnWidth,
                gutter:props.size.gutter,
                depthConversion:props.size.depthConversion,
                modYNB:props.size.modYNB,
                EPSPathNum:props.size.EPSPathNum,
                tempChar:props.size.tempChar||"",
                tempInt:props.size.tempInt||0,
                siteCode:props.size.siteCode||"", 
            });            
        }
        setIntAction(props.action);
        if (props.action==="Edit"){
            viewDeleteButton();
        }else{
            hideDeleteButton();
        }
    },[]);
    return(
        <>
        <Dialog title={dlgTitle} onClose={props.onClose} width={700} height={"45vh"}>
            {showDelConfirm?<ConfirmDialog title='Delete Sub-status Entry' message='This will permanently delete the selected sub-status entry. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDelConfirm} onConfirm={deleteThisSize}  ></ConfirmDialog>:null}

            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Site:</Label></Col>
                <Col xs="9"><SiteList value={newSize.siteCode} setReturnAction={setSiteCode} multi={false} valid={siteValid} className="" ></SiteList></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Ad Type:</Label></Col>
                <Col xs="9"><Input value={newSize.category} onChange={setCategory} required={true}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Column Width:</Label></Col>
                <Col xs="9"><Input value={newSize.columnWidth} onChange={setColWidth}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Gutter:</Label></Col>
                <Col xs="9"><Input value={newSize.gutter} onChange={setGutter}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Depth Conversion:</Label></Col>
                <Col xs="9"><Input value={newSize.depthConversion} onChange={setDepthConv}></Input></Col>
            </Row>
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
                <Button themeColor={"primary"} onClick={saveThisSize}>Save</Button>
                {showDeleteButton?<Button themeColor={"warning"} onClick={viewDelConfirm}>Delete</Button>:null}
            </DialogActionsBar>
        </Dialog>
        </>
    )
}

export default function AdminSizes (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [sizes, setSizes] = useState([]);
    const [sizeSelected, setSizeSelected]=useState<DatCatSizeDataItem>();
    const [showEditDialog,setShowEditDialog]=useState(false);
    const [title,setTitle]=useState("");
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(sizes,dataState));
    //const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const idGetter = getter('pubNum');

    const setSelectedSize=(size:DatCatSizeDataItem)=>{
        setSizeSelected(size);
    }

    const hideEditDialog=()=>{
        setShowEditDialog(false);
        getSizes();
    }

    const newEditDialog=(e: React.MouseEvent<HTMLButtonElement>)=>{
        setAction("New");
        setTitle("New Size");
        setSizeSelected( {
            category:"",
            columnWidth:0,
            gutter:0,
            depthConversion:0,
            modYNB:"",
            EPSPathNum:0,
            tempChar:"",
            tempInt:0,
            siteCode:"",
        })
        setShowEditDialog(true);
    }



    const getSizes=()=>{
        getDatCatSizeList().then(data=>{
            setSizes(data);
            //setDataResult(process(data, dataState));
        })
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        setDataState(e.dataState);
        //setDataResult(process(sizes, e.dataState));
    };

    const processedData=process(sizes,dataState);
    // const pageChange = (event: GridPageChangeEvent) => {
    //     const targetEvent = event.targetEvent as PagerTargetEvent;        
    //     setPage({
    //         ...event.page,
    //         take:20
    //     });
    // }

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        console.log(event.startDataItem);
        const size:DatCatSizeDataItem=event.startDataItem;
        setSizeSelected(size);

        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "category"
        });
        console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
    };

    useEffect(()=>{
        console.log(sizeSelected);
        if (sizeSelected){
            setTitle("Size Configuration for: " + sizeSelected?.category);
            setShowEditDialog(true);
        }
    },[sizeSelected])
   
    useEffect(() => {   
        if (user?.loggedIn){
            getSizes();
        }else{
            window.location.replace("/Login");
        }
    }, []);

    return (
        <>
        {user?.loggedIn && user.type==5 ?
        <Container fluid>
            <h2>Size/Category Management</h2>
            <Toolbar>
                <Button title="New Size" themeColor={'primary'} type="button" onClick={newEditDialog}>
                    New Size
                </Button>       
            </Toolbar>
            <Grid
                data={processedData}
                // data={(dataResult.data.slice(page.skip, page.take + page.skip))?.map((item)=>({
                //     ...item, 'selected':selectedState[idGetter(item)]
                // }))}
                dataItemKey='UID'
                id="sizeGrid"
                className='adminGrid'
                sortable={true}
                selectable={{ enabled:true, mode: 'single' }}
                pageable={{
                    buttonCount: 4,
                    info:true,                
                    pageSizeValue: 20
                }}
                {...dataState}
                onDataStateChange={onDataStateChange}
                //onPageChange={pageChange}
                onSelectionChange={onSelectionChange}
                //skip={page.skip}
                //take={page.take}
                //total={dataResult.total}
                reorderable={true}
                filterable={true}
            >
                <GridColumn field='siteCode' title='Site' width={150} />
                <GridColumn field='category' title='Category'/>
                <GridColumn field='columnWidth' title='Column Width'/>
                <GridColumn field='gutter' title='Gutter'/>
                <GridColumn field='depthConversion' title='Depth Conversion'/>
                <GridColumn field='tempChar' title='Display Name'/>
            </Grid>
            {showEditDialog?
                <EditDialog title={title} size={sizeSelected as DatCatSizeDataItem} onClose={hideEditDialog} action={action}></EditDialog>
            :null
            }
        </Container>
        : <></>}
        </>
    );
}